import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule, TrackingData } from '@ecm/router';

import { PushSubItemViewModel } from '../../../../business/model/home/pushSubItem.view-model';
import { ParamsUtils } from '../../../../utils/params.utils';
import { SubItemComponent } from '../sub-item.component';

@Component({
    selector: 'commercial-sub-item',
    templateUrl: 'commercial-sub-item.html',
    styleUrls: ['../sub-item.css'],
    standalone: true,
    imports: [EcmMaterialModule, NgTemplateOutlet, NgClass, AsyncPipe, EcmRouterModule],
})
export class CommercialSubItemComponent extends SubItemComponent implements OnInit {
    @Input()
    public viewModel: PushSubItemViewModel;

    public ngOnInit(): void {
        const isSosh = this.isSoshBrand();
        if (isSosh) {
            this.viewModel.zid = this.uaService.isMobile() ? this.viewModel.zidSoshMob : this.viewModel.zidSosh;
        } else {
            this.viewModel.zid = this.uaService.isMobile() ? this.viewModel.zidMob : this.viewModel.zid;
        }
    }

    /**
     * Open item link
     */
    public openLink(): void {
        if (this.viewModel.link) {
            this.linkService.openLink(
                this.viewModel.link,
                Object.assign(new TrackingData(), {
                    cappingTracking: {
                        advTracker: this.viewModel.advTracker,
                        code: this.viewModel.code,
                        cid: this.viewModel.cid,
                    },
                    featureName: 'dashboard',
                    functionality: this.viewModel.functionality,
                }),
                ParamsUtils.cidMap(this.viewModel.cid),
            );
        }
    }
}
